import { useEffect, useState } from 'react'

/** A lookup owns its error and ignores results from superseded selections. */
export function useVmLookup<T>(load: () => Promise<T>) {
  const [attempt, setAttempt] = useState(0)
  const [state, setState] = useState<{ data?: T; error?: string; loading: boolean }>({
    loading: true,
  })
  useEffect(() => {
    let current = true
    setState({ loading: true })
    void load()
      .then((data) => {
        if (current) setState({ data, loading: false })
      })
      .catch(() => {
        if (current) setState({ error: 'lookupFailed', loading: false })
      })
    return () => {
      current = false
    }
  }, [load, attempt])
  return { ...state, retry: () => setAttempt((n) => n + 1) }
}

export async function allPages<T>(
  load: (page: number) => Promise<{ data: T[]; total: number }>
): Promise<T[]> {
  const result: T[] = []
  for (let page = 1; ; page++) {
    const response = await load(page)
    const rows = response.data ?? []
    result.push(...rows)
    if (result.length >= response.total) return result
    if (!rows.length || page >= 1000) throw new Error('Incomplete paginated lookup')
  }
}
